import React from "react";
import './AppPrivacyPolicy.css'

const AppPrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
    
      <h1 style={{textAlign:'center'}}> App Privacy Policy</h1>
      <main className="privacy-policy__main">
        
        <div className="privacy-policy__container">
          <div className="privacy-policy__content">
            <p className="privacy-policy__intro">
              Yug Mantra is an electronic platform for commerce, specializing exclusively in blouse designs and related accessories. Yug Mantra recognizes the importance of your privacy and maintaining the confidentiality of your personal information. This Privacy Policy applies to all products and services provided by us and describes how we may collect, use and disclose information related to users of this site.
            </p>

            <div className="privacy-policy__section">
              <h2 className="privacy-policy__section-title">Information Collection</h2>
              <p>We collect information about you for 2 reasons: firstly, to process your blouse order and second, to provide you with the best possible service for your blouse shopping experience.</p>
            </div>

            <div className="privacy-policy__section">
              <h2 className="privacy-policy__section-title">Email Communications</h2>
              <ul className="privacy-policy__list">
                <li>We will not e-mail you in the future unless you have given us your consent.</li>
                <li>We will give you the chance to refuse any marketing email from us or from another trader in the future.</li>
              </ul>
            </div>

            <div className="privacy-policy__section">
              <h2 className="privacy-policy__section-title">Personal Information We Collect</h2>
              <p>The type of information we will collect about you includes:</p>
              <ul className="privacy-policy__list">
                <li>Your Name</li>
                <li>Address (for blouse delivery)</li>
                <li>Phone Number</li>
                <li>Email Address</li>
                <li>Payment Information (processed securely through our payment partners)</li>
                <li>Blouse Order History and Preferences</li>
                <li>Size and Style Preferences for Blouses</li>
              </ul>
            </div>

            <div className="privacy-policy__section">
              <h2 className="privacy-policy__section-title">Sensitive Information</h2>
              <p>We will never collect sensitive information about you without your explicit consent.</p>
            </div>

            <div className="privacy-policy__section">
              <h2 className="privacy-policy__section-title">Data Security</h2>
              <p>The personal information which we hold will be held securely in accordance with our internal security policy and the law.</p>
            </div>

            <div className="privacy-policy__section">
              <h2 className="privacy-policy__section-title">Contact Us</h2>
              <p>If you have any questions/comments about privacy, you should contact us at:</p>
              <div className="privacy-policy__contact">
                <p><strong>Phone:</strong> +91-7490026756</p>
                <p><strong>Email:</strong> info@siddharthfashion.com</p>
              </div>
            </div>
          </div>
        </div>
      </main>

    </div>
  );
};

export default AppPrivacyPolicy;